import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(advancedFormat);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 0 });

export { dayjs as dayJs };

export const FULL_DATE_STRING_FORMAT = 'dddd Do of MMMM YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';

export function formatDate(date = new Date(), format = DISPLAY_DATE_FORMAT, defaultValue = null) {
  const parsedDate = dayjs(date);

  return parsedDate.isValid() ? parsedDate.format(format) : defaultValue;
}

export const toDate = (date = new Date(), defaultValue = null) => {
  const parsedDate = dayjs(date);

  return parsedDate.isValid() ? parsedDate.toDate() : defaultValue;
};

export const toDayjs = (date = null, defaultValue = null) => (date ? dayjs(date) : defaultValue);

export const getTomorrowDate = (date = new Date(), defaultValue = null) => {
  const tomorrowDate = dayjs(date).add(1, 'day');

  return tomorrowDate.isValid() ? new Date(tomorrowDate) : defaultValue;
};

export const checkIsDeadlinePassed = (date = new Date()) => dayjs(date).isBefore(new Date(), 'day');

export const getDateWeekday = (date = null, defaultValue = null) => {
  const parsedDate = dayjs(date);

  return parsedDate.isValid() ? dayjs(parsedDate).isoWeekday() - 1 : defaultValue;
};

export const getLastKeyEventDatePlaceholder = (date) => dayjs(date).add(5, 'year').format('YYYY/MM/DD');

export const getStartOfMonth = (date = new Date()) => dayjs(date).startOf('month');

export const getMonthlyDatesInGap = (startDate) => {
  const start = getStartOfMonth(startDate);
  const end = dayjs().startOf('month');

  const monthsCount = Math.max(1, end.diff(start, 'month') + 1);

  return Array.from({ length: monthsCount }, (_, index) => {
    const current = start.add(index, 'month');

    return formatDate(current, API_DATE_FORMAT);
  }).toReversed();
};

export const getMonthYearFromDate = (date = new Date()) => {
  const parsedDate = dayjs(date);

  return {
    month: parsedDate.month() + 1, // dayjs months are 0-based
    year: parsedDate.year(),
  };
};
